<template>
  <v-btn
    icon
    size="small"
    variant="text"
    class="close-button"
    @click="handleClose"
  >
    <v-icon icon="mdi-close" size="large"></v-icon>
    <v-tooltip activator="parent" location="bottom"> Close </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  name: 'ACloseButton',
  emits: ['close'],

  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="sass">
.close-button
	margin-right: 8px
	opacity: 0.7
	transition: opacity 0.2s ease

	&:hover
		opacity: 1
</style>
